<template>
  <v-dialog v-model="dialog" scrollable max-width="500">
    <v-btn slot="activator" flat icon class="btn-toolbar">
      <v-badge v-model="isSelected" overlap color="orange">
        <span slot="badge">{{ (value || []).length }}</span>
        <v-icon>filter_list</v-icon>
      </v-badge>
    </v-btn>
    <v-card class="pa-2">
      <v-card-title>
        <span class="headline px-2">Displayed Columns</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-xs>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="viewItems"
            select-all
            :pagination.sync="pagination"
            disable-initial-sort
            hide-actions
            item-key="key"
            class="elevation-1"
          >
          <template slot="headers" slot-scope="props">
            <tr>
              <th>
                <v-checkbox
                  primary
                  hide-details
                  @click.native="toggleAll"
                  :input-value="props.all"
                  :indeterminate="props.indeterminate"
                ></v-checkbox>
              </th>
              <th v-for="header in props.headers" :key="header.key"
                :class="['column', pagination.descending ? 'desc' : 'asc', 'active', 'text-xs-left']"
                @click.stop.prevent="toggleAll"
              >
                {{ header.key }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr :active="props.selected" @click="props.selected = !props.selected" class="cursor-default">
              <td>
                <v-checkbox
                  primary
                  hide-details
                  :input-value="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.value }}</td>
            </tr>
          </template>
        </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" flat @click.native="close()">Close</v-btn>
        <v-btn color="primary" dark @click.native="submit()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { titleText } from '../../libs/utils'

  export default {
    props: {
      value: { required: false },
      items: { type: Array, required: true }
    },
    data () {
      return {
        dialog: false,
        selected: [],
        initialItems: [],
        viewItems: this.getMapValues(this.items),
        pagination: {
          rowsPerPage: -1
        },
        headers: this.getMapValues(['Select All'])
      }
    },
    computed: {
      isSelected () {
        return (this.value || []).length !== this.items.length
      }
    },
    watch: {
      dialog () {
        this.dialog ? this.open() : this.close()
      }
    },
    methods: {
      open () {
        this.dialog = true
        this.initialItems = [...this.value]
        this.reset()
      },
      close () {
        this.dialog = false
      },
      reset () {
        this.selected = this.getMapValues([...this.initialItems])
      },
      submit () {
        this.$emit('input', this.selected.map(item => item.key))
        this.close()
      },
      label (txt) {
        return titleText(txt)
      },
      getMapValues (items) {
        return items.map(item => ({ key: item, value: this.label(item) }))
      },
      toggleAll () {
        if (this.selected.length) this.selected = []
        else this.selected = this.viewItems.slice()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .cursor-default {
    cursor: default;
  }
</style>
